<app-ace-select #levelSelect
                [appendTo]="appendTo"
                [items]="levelOptions"
                [bindValue]="bindToLevelId ? 'level_id' : null"
                [bindLabel]="'level_name'"
                [placeholder]="placeholder"
                [multiSelect]="multiSelect"
                [maxSelectedLabels]="maxSelectedLabels"
                [hideSelected]="false"
                [loading]="loading"
                (touched)="onTouched()"
                (openEvent)="onOpen()"
                (closeEvent)="onClose()">
  <ng-template #optionTemplate let-level="item">
    @if (!showSite) {
      <div class="ng-value-label">
        <div>{{ level.level_name }}</div>
      </div>
    } @else {
      <div class="row ng-value-label">
        <div class="col">
          <div>{{ level.level_name }}</div>
        </div>
        <div class="col">
          <div class="float-end text-secondary smaller-font pt-1">{{ level['site_name'] }}</div>
        </div>
      </div>
    }
  </ng-template>
</app-ace-select>

@if (showSelectAll) {
  <div>
    <button class="btn btn-sm btn-link p-0" type="button" (click)="selectAll($event)">{{ 'Select All' | messageTranslate }}</button>
  </div>
}
